(function(runtime) {
    var _ = runtime.components.dependencies._;
    var Modernizr = runtime.components.dependencies.Modernizr;

    var constants = runtime.components.constants.merge({
       choice: {
            selector: '.ixp-component-choice',
            groupSelector: '.ixp-component-choice-group[' + runtime.components.constants.components.data.componentRoot + ']',
            childOverrideSelector: '.ixp-component-choice-override',

           css: {
                modePrefix: 'ixp-component-choice-mode-',
                stateOn: 'ixp-component-choice-on',
                stateOff: 'ixp-component-choice-off',
                override: 'ixp-component-choice-override',
                noOverride: 'ixp-component-choice-no-override',
                dataValueIncomplete: 'ixp-input-validation-data-value-incomplete'
            },

           extensibility: {
               events: {
                   stateChanging: ':state:changing',
                   stateChanged: ':state:changed'
               }
           }
       },

        choiceGroup: {
            descendantSelector: '.ixp-component-choice-group[' + runtime.components.constants.components.data.componentRoot + ']',

            css: {
                selectModePrefix: 'ixp-component-choice-group-select-mode-'
            },

            selectModes: {
                single: 'single',
                multiple: 'multi'
            }
        },

        events: {
            choiceChanged: ':choice:changed',
            choiceRequestStateChange: ':choice:requestStateChange',
            choiceGroupInitialized: ':choiceGroup:initialized'
        },

        keyboardKeys: {
            space: 32
        }
    });

    runtime.components.registerExtensibility('ixp-choice', {
        commands: constants.choice.extensibility.commands || {},
        events:   constants.choice.extensibility.events || {}
    });

    var statics = {
        choiceCssClassesToPreserve: [
            constants.choice.css.modePrefix + 'simple',
            constants.choice.css.modePrefix + 'advanced',
            constants.choice.css.stateOn,
            constants.choice.css.stateOff,
            constants.choice.css.override,
            constants.choice.css.noOverride
        ],

        choiceGroupCssClassesToPreserve: [
            constants.choiceGroup.css.selectModePrefix + constants.choiceGroup.selectModes.single,
            constants.choiceGroup.css.selectModePrefix + constants.choiceGroup.selectModes.multiple
        ],

        arrayToCsv: function(data) {
            var i,
                value;

            for (i = 0; i < data.length; i++) {
                value = data[i];
                if (value.indexOf(',') !== -1 || value.indexOf('"') !== -1) {
                    data[i] = '"' + value.replace(/"/g, '""') + '"';
                }
            }

            return data.join(',');
        },

        csvToArray: function(data) {
            if (!data) {
                return [ [] ];
            }

            // Create a regular expression to parse the CSV values.
            var objPattern = new RegExp(
                (
                    // Delimiters.
                    "(\\,|\\r?\\n|\\r|^)" +

                    // Quoted fields.
                    "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +

                    // Standard fields.
                    "([^\"\\,\\r\\n]*))"
                    ),
                "gi"
            );

            // Create an array to hold our data. Give the array a default empty first row.
            var results = [ [] ];

            // Create an array to hold our individual pattern matching groups.
            var matches;
            var matchedDelimiter;
            var matchedValue;

            // Keep looping over the regular expression matches until we can no longer find a match.
            while (matches = objPattern.exec(data)) {
                // Get the delimiter that was found.
                matchedDelimiter = matches[1];

                // Check to see if the given delimiter has a length (is not the start of string) and if it matches field delimiter.
                // If id does not, then we know that this delimiter is a row delimiter.
                if (matchedDelimiter.length && (matchedDelimiter != ',')) {
                    // Since we have reached a new row of data, add an empty row to our data array.
                    results.push([]);
                }

                // Now that we have our delimiter out of the way, let's check to see which kind of value we captured (quoted or unquoted).
                if (matches[2]) {
                    // We found a quoted value. When we capture this value, unescape any double quotes.
                    matchedValue = matches[2].replace(new RegExp("\"\"", "g"), "\"");
                } else {
                    // We found a non-quoted value.
                    matchedValue = matches[3];
                }

                // Now that we have our value string, let's add it to the data array.
                results[results.length - 1].push(matchedValue);
            }

            // Return the parsed data.
            return results;
        },

        getChoiceScaffolding: function(scaffoldingKey, builder, options) {
            return {
                style: {
                    customClass: builder.getDefaultTheme('choice')
                }
            };
        },

        getChoiceGroupScaffolding: function(scaffoldingKey, builder, options) {
            var group = { scaffolding: builder.scaffoldContainer('Choice Group')};

            var choices = [];
            for (var i = 1; i < 3; i++) {
                var choice = builder.scaffold('ixp-choice', 'Choice');
                choice.style.customClass = builder.getDefaultTheme('choice');
                choices.push(choice);
            }

            group.scaffolding.content.scaffolding = choices;

            return {
                scaffolding: [ group.scaffolding ],
                style: {
                    customClass: builder.getDefaultThemes({ 'choicegroup': '', 'choicegroup-layout': 'ixp-component-choice-group-inline' })
                }
            };
        }
    };

    runtime.components.register('ixp-choice', {
        initialize: function(options) {
            var $group = this.$el.closest(constants.choice.groupSelector);
            this.groupInstanceId = $group.attr(constants.components.data.componentRoot);

            var $form = $group.closest(constants.inputs.formSelector);
            this.formInstanceId = $form.attr(constants.components.data.componentRoot);

            this.state = {
                instanceId: this.instanceId,
                dataValue: this.dataValue
            };
            this._setChoiceState(this.defaultState === 'on');

            var hasOverride = this.$el.hasClass(constants.choice.css.override) ||
                              this.$el.find(constants.choice.childOverrideSelector).length;

            this.$el
                .toggleClass(constants.choice.css.noOverride, !hasOverride)
                .toggleClass(constants.inputs.css.required, this.required)
                .attr(constants.inputs.data.submitUrl, this.submitUrl);

            if (this.inStudio) {
                return;
            }

            runtime.events.on(this, this.groupInstanceId + constants.events.choiceGroupInitialized, this._onChoiceGroupInitialized);
            runtime.events.on(this, this.groupInstanceId + constants.events.choiceRequestStateChange, this._onSetChoiceState);
            this.$el.on('click' + this.eventNamespace, _.bind(this._onClicked, this));
            this.$el.on('keydown' + this.eventNamespace, _.bind(this._onKeyDown, this));
        },

        getValue: function() {
            return this.state.on ? this.dataValue : '';
        },

        onRegisterDataField: function() { },

        _setChoiceState: function(on) {
            this.state.on = on;
            this.state.value = this.getValue();
            this.state.hasValue = !this._isValueEmpty(this.state.value);
            this.state.required = this.required;

            this.$el.attr(constants.inputs.data.state, JSON.stringify(this.state));

            this.$el
                .toggleClass(constants.choice.css.stateOn, on)
                .toggleClass(constants.choice.css.stateOff, !on);

            this._setAriaRoles();

            if (this.groupSelectMode === constants.choiceGroup.selectModes.single) {
                this._updateRadioTabIndexValues();
            }

            if (this.inStudio) {
                this._setInStudioValidation();
            }
        },

        _setInStudioValidation: function() {
            this.$el.toggleClass(constants.choice.css.dataValueIncomplete, !this.state.dataValue);
        },

        _setAriaRoles: function() {
            switch (this.groupSelectMode) {
                case constants.choiceGroup.selectModes.single:
                    this.$el
                        .attr('role', 'radio')
                        .attr('aria-checked', this.state.on);
                    break;
                case constants.choiceGroup.selectModes.multiple:
                    this.$el
                        .attr('role', 'checkbox')
                        .attr('aria-checked', this.state.on);
                    break;
            }
        },

        _onChoiceGroupInitialized: function(e) {
            this.groupSelectMode = e.selectMode;
            this._setAriaRoles();
            if (this.groupSelectMode === constants.choiceGroup.selectModes.single) {
                this._setInitialRadioTabIndexValues();
            }
        },

        _updateRadioTabIndexValues: function () {
            if (this.state.on) {
                this.$el.attr('tabindex', '0');
            }
            else {
                this.$el.attr('tabindex', '-1');
            }
        },

        _setInitialRadioTabIndexValues: function () {
            var choiceSelector = constants.choice.selector.substring(1);
            var isFirstRadioChoice = this.$el.hasClass(choiceSelector) && !this.$el.prev().hasClass(choiceSelector);
            if (isFirstRadioChoice) {
                this.$el.attr('tabindex', '0');
            }
            else {
                this.$el.attr('tabindex', '-1');
            }
        },

        _onSetChoiceState: function(e) {
            if (e.skipInstanceId === this.instanceId) {
                return;
            }

            var on = false;
            if (e.values && e.values.length) {
                on = this.$.inArray(this.dataValue, e.values) !== -1;
            }

            this._setChoiceState(on)
        },

        _onClicked: function(e) {
            if (this.formInstanceId) {
                var submitting = false;

                this.sendCommand(constants.extensibility.inputs.commands.status, this.formInstanceId, {
                    done: function(ee) {
                        submitting = ee && ee.data.submitting;
                    }
                });

                if (submitting) {
                    return;
                }
            }

            this._onStateChanged(e, !this.state.on);
        },

        _onKeyDown: function (e) {
            var spaceKey = constants.keyboardKeys.space;
            if (e.which === spaceKey) {
                var on = this.state.on;

                this._onStateChanged(e, !on);

                if (on !== this.state.on) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    e.preventDefault();
                }
            }
        },

        _onStateChanged: function(e, on) {
            if (this.groupSelectMode === constants.choiceGroup.selectModes.single) {
                if (this.$el.hasClass(constants.inputs.css.validationPrefix + constants.inputs.states.pending)) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    return;
                }

                if (this.state.on) {
                    return;
                }
            }

            var ee = {
                selected: on,
                dataValue: this.state.dataValue,
                required: this.state.required,
                cancel: false
            };
            this.triggerExtensibility(constants.choice.extensibility.events.stateChanging, ee);
            if (ee.cancel) {
                return;
            }

            this._setChoiceState(on);
            this._triggerChoiceChanged();

            ee = {
                selected: this.state.on,
                dataValue: this.state.dataValue,
                required: this.state.required
            };
            this.triggerExtensibility(constants.choice.extensibility.events.stateChanged, ee);
        },

        _triggerChoiceChanged: function() {
            var e = {
                element: this.$el[0],
                instanceId: this.instanceId,
                value: this.state.value,
                hasValue: this.state.hasValue,
                required: this.state.required,
                submitUrl: this.submitUrl
            };

            runtime.events.trigger(this.groupInstanceId + constants.events.choiceChanged, e);
        },

        _isValueEmpty: function(value) {
            return (value == null || value === '');
        },

        studioInitialize: function(options) {
            this.$el.attr('tabindex', -1);
            this._studioSetMode();
        },

        _studioSetMode: function() {
            var simpleContainer = this.$el.find('.ixp-component-choice-simple-container').first();
            var expandedContainers = this.$el.find('.ixp-component-choice-on-container:first, .ixp-component-choice-off-container:first');

            if (this.mode === 'simple') {
                simpleContainer.removeAttr(constants.components.studio.data.hidden);
                expandedContainers.attr(constants.components.studio.data.hidden, true);
            } else if (this.mode === 'advanced') {
                simpleContainer.attr(constants.components.studio.data.hidden, true);
                expandedContainers.removeAttr(constants.components.studio.data.hidden);
            }
        },

        getParamMapOverrides: function() {
            return {
                required: function(val) {
                    this.required = (val === true || val === 'true');
                    this.$el.toggleClass(constants.inputs.css.required, this.required);
                },

                mode: function(val) {
                    this.$el.removeClass(constants.choice.css.modePrefix + this.mode);
                    this.mode = val;
                    this.$el.addClass(constants.choice.css.modePrefix + this.mode);

                    this._studioSetMode();

                    this.studioApp.componentsManager.trigger(constants.components.studio.events.reflow, { instanceId: this.instanceId });
                },

                submitUrl: function(val) {
                    this.submitUrl = val;
                    this.$el.attr(constants.inputs.data.submitUrl, this.submitUrl);
                },

                defaultState: function(val) {
                    this.defaultState = val;
                    this._setChoiceState(this.defaultState === 'on');
                },

                dataValue: function(val) {
                    val || (val = null);
                    this.state.dataValue = val;
                    this.$el.attr(constants.inputs.data.state, JSON.stringify(this.state));
                    this._setInStudioValidation();
                }
            };
        },

        onListenToStudioEvents: function(events) {
            events.on('element:microtheme:applied', _.bind(this._onMicroThemeApplied, this));
            events.on('element:microtheme:removed', _.bind(this._onMicroThemeRemoved, this));
        },

        _hasOverride: function(){
            return this.$el.hasClass(constants.choice.css.override) ||
                this.$el.find(constants.choice.childOverrideSelector).length;
        },

        _onMicroThemeApplied: function(e) {
            if (this.instanceId === e.model.get('elementId')) {
                var hasOverride = this._hasOverride();
                this.$el.toggleClass(constants.choice.css.noOverride, !hasOverride);
            }
            this._setInStudioValidation();
        },

        _onMicroThemeRemoved: function(e) {
            if (this.instanceId === e.model.get('elementId')) {
                var hasOverride = this._hasOverride();
                if (hasOverride) {
                    this.$el.removeClass(constants.choice.css.override);
                    this.$el.addClass(constants.choice.css.noOverride);
                }
            }
            this._setInStudioValidation();
        },

        allowedDropTargets: function() {
            return ['ixp-choice-group'];
        },

        disallowedChildrenTypes: function() {
            return ['ixp-choice', 'ixp-form'];
        },

        onGetCssClassesToPreserve: function() {
            return statics.choiceCssClassesToPreserve;
        },

        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return statics.getChoiceScaffolding(scaffoldingKey, builder, options);
        }
    });

    runtime.components.register('ixp-choice-group', runtime.components.InputComponentBase, {
        initialize: function(options) {
            this._setSelectionState();
            this._setInitialValue();

            var e = {
                selectMode: this.multiselect
                    ? constants.choiceGroup.selectModes.multiple
                    : constants.choiceGroup.selectModes.single
            };
            runtime.events.trigger(this.instanceId + constants.events.choiceGroupInitialized, e);
            runtime.events.on(this, this.state.instanceId + constants.inputs.events.formFieldInputRegistered, this._onFormFieldInputRegistered);
        },

        onListenToInputEvents: function() {
            runtime.events.on(this, this.instanceId + constants.events.choiceChanged, this._onChoiceChanged);

            if (!this.multiselect) {
                this.$el.on('keydown' + this.eventNamespace, _.bind(this._onKeyDown, this));
            }
        },

        getValue: function() {
            return this._computeValues();
        },

        onSetValue: function(value) {
            this._setChoices(this._getValues(value));
        },

        _getValues: function(value) {
            return statics.csvToArray(value)[0];
        },

        setFocus: function() {
            // First select the field (or choice-group if there is no field) to make sure its in view, then select the first choice
            var $field = this.$el.closest(constants.inputs.formFieldSelector);
            if ($field.length) {
                $field.attr('tabindex', 0);
                $field.focus();
                $field.removeAttr('tabindex');
            } else {
                this.$el.attr('tabindex', 0);
                this.$el.focus();
                this.$el.removeAttr('tabindex');
            }
            this._getChoices().first().focus();
        },

        isIncomplete: function(value) {
            return this.state.required && (this.isValueEmpty(value) || this.missingRequiredChoices);
        },

        onValidate: function(value, validationState) {
            var valid = runtime.components.InputComponentBase.prototype.onValidate.apply(this, arguments);

            if (valid && this.required && !this.multiselect) {
                var values = this._getValues(value);
                if (values.length > 1) {
                    return false;
                }
            }

            return valid;
        },

        _setInitialValue: function() {
            if (!this.inStudio) {
                var setChoices = false;

                var defaultValue;
                if (this.defaultValueType === 'datafield') {
                    if (this.dataContext.hasValue) {
                        defaultValue = this.dataContext.value;
                        setChoices = true;
                    } else if (this.dataContext.hasDefaultValue) {
                        defaultValue = this.dataContext.defaultValue;
                        setChoices = true;
                    }
                }

                // If we have no default, and we are single-select make sure the user-set choice states are valid
                if (defaultValue === undefined && !this.multiselect) {
                    defaultValue = this.getValue();
                }

                if (defaultValue !== undefined) {
                    var values = this._getValues(defaultValue);

                    if (!this.multiselect) {
                        if (values.length > 1) {
                            values = values.slice(0, 1);
                            setChoices = true;
                        }
                    }

                    if (setChoices) {
                        this._setChoices(values);
                    }
                }

                this.$el.attr('role','group');
            }

            this.validate();
        },

        _getChoices: function() {
            return this.filterChildren(constants.choice.selector, constants.choiceGroup.descendantSelector);
        },

        _computeValues: function() {
            var me = this;
            var missingRequiredChoices = false;
            var hasRequiredChoices = false;
            var values = [];

            var $choices = this._getChoices();
            $choices.each(function() {
                var $el = me.$(this);

                var state = $el.attr(constants.inputs.data.state);
                if (state) {
                    state = JSON.parse(state);

                    var value = state.value;
                    hasRequiredChoices = hasRequiredChoices || state.required;

                    if (state.hasValue) {
                        values.push(value);
                    } else if (state.required) {
                        missingRequiredChoices = true;
                    }
                }
            });

            var value = statics.arrayToCsv(values);

            this.state.required = this.required || hasRequiredChoices;
            this.missingRequiredChoices = missingRequiredChoices;

            return value;
        },

        _onChoiceChanged: function(e) {
            if (!this.multiselect) {
                this._setChoices(e.values || [], e.instanceId);

                this._getChoices().addClass(constants.inputs.css.validationPrefix + constants.inputs.states.pending);
            }

            this.onInputChanged();
        },

        _onKeyDown: function(e) {
            var direction;

            // ArrowLeft, NumArrowLeft, ArrowUp, NumArrowUp
            if (e.which === 37 || e.which === 100 || e.which === 38 || e.which === 104) {
                direction = 'prev';
            // ArrowRight, NumArrowRight, ArrowDown, NumArrowDown
            } else if (e.which === 39 || e.which === 102 || e.which === 40 || e.which === 98) {
                direction = 'next';
            }

            if (!direction) {
                return;
            }

            var $selected = this._getChoices().filter(function (_, element) {
                return element === document.activeElement;
            });

            if (!$selected.length) {
                return;
            }

            $selected = $selected[direction](constants.choice.selector);
            if (!$selected.length) {
                return;
            }

            var state = $selected.attr(constants.inputs.data.state);
            if (state) {
                state = JSON.parse(state);
                if (state.dataValue) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    e.preventDefault();

                    $selected.focus();
                    this._onChoiceChanged({ values: [state.dataValue] });
                }
            }
        },

        triggerInputChanged: function() {
            if (!this.multiselect) {
                this._getChoices().removeClass(constants.inputs.css.validationPrefix + constants.inputs.states.pending);
            }

            runtime.components.InputComponentBase.prototype.triggerInputChanged.apply(this, arguments);

            // http://stackoverflow.com/questions/3350441/dynamic-elements-are-not-appearing-in-ie8-until-there-is-a-mouse-click
            this.$el.addClass('ie8').removeClass('ie8');
        },

        _setChoices: function(values, instanceId) {
            var e = {
                skipInstanceId: instanceId,
                values: values || []
            };
            runtime.events.trigger(this.instanceId + constants.events.choiceRequestStateChange, e);
        },

        _setSelectionState: function() {
            this.$el
                .toggleClass(constants.choiceGroup.css.selectModePrefix + constants.choiceGroup.selectModes.single, !this.multiselect)
                .toggleClass(constants.choiceGroup.css.selectModePrefix + constants.choiceGroup.selectModes.multiple, this.multiselect);
        },

        _onFormFieldInputRegistered: function(e) {          
            var  textFieldLabel = this.$(e.labelContainerSelector).get(0);
            this.setAriaLabelAttribute(textFieldLabel);
        },

        setAriaLabelAttribute: function (textFieldLabel) {
            if(!textFieldLabel || !textFieldLabel['id']) return;
            this.$el.attr('aria-labelledby', textFieldLabel.id);
        },

        getParamMapOverrides: function() {
            return {
                multiselect: function(val) {
                    this.multiselect = (val === true || val === 'true');
                    this._setSelectionState();
                },
                dataField: function(val) {
                    this.dataField = val ? val : null;
                }
            }
        },

        allowedDropTargets: function(origin) {
            if (origin === 'element'){
                return ['ixp-form-field'];
            }
            return ['ixp-form', 'ixp-form-field'];
        },

        onGetCssClassesToPreserve: function() {
            return statics.choiceGroupCssClassesToPreserve;
        },

        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return statics.getChoiceGroupScaffolding(scaffoldingKey, builder, options);
        }
    });
})(window.ixp.runtime);